/**
 *
 */
export default function (model, error) {

    //
    var messages = []

    //
    if ( error.error ) messages.push(error.error)

    //
    if ( error.errors ) {
        Object.keys( error.errors ).forEach( key => {
            error.errors[ key ].forEach( message => {

                //
                let text = [
                    model.errors[ key ] ? model.errors[ key ].name : key,
                    message,
                ].join(": ")

                //
                if ( model.errors[ key ] ) {

                    //
                    model.errors[ key ].translates.forEach( item => {
                        text = text.replace( item.translate, item.value )
                    })
                }

                // 
                if ( model.errors[ "_default" ] ) {

                    //
                    model.errors[ "_default" ].translates.forEach( item => {
                        text = text.replace( item.translate, item.value )
                    })
                }

                //
                messages.push(text)
            })

        })
    }

    //
    return messages.join("\n")
}